/**
 * 全国美术院校附中
 */
import axios from '../utils/http';

/**
 * @description 获取文章列表
 * @param {number} classid 文章分类id 
 */
const getArticleList = params => {
    return axios.request({
        data: {
            ...params
        },
        method: 'get',
        url: '/v1/article/getArticleList'
    })
}
/**
 * @description 获取院校列表
 * @param {number} cid 院校级别 
 */
 const getSchoolList = params => {
    return axios.request({
        data: {
            ...params
        },
        method: 'get',
        url: '/colleges/data1'
    })
}
 
export default {
    getArticleList,
    getSchoolList
}